import { get } from "../axiosConfig";
import { Level } from "../../../types";

export const LevelsAPI = {
  async getLevels(): Promise<Level[]> {
    const { data } = await get("/levels");
    return data;
  },
};
